export default __webpack_public_path__ + "media/quote-left.02d9faf4.svg";